/**
 * Build a string-keyed lookup from a list of entries. Shared by the entity-card action
 * registry and the stream-component registry, both of which collect self-describing
 * entries (each carrying its own key) and look them up by a backend enum string.
 */
export function createRegistry<TEntry>(entries: TEntry[], keyOf: (entry: TEntry) => string): Record<string, TEntry> {
  const registry: Record<string, TEntry> = {};

  for (const entry of entries) {
    registry[keyOf(entry)] = entry;
  }

  return registry;
}
